import { Component } from '@angular/core';

@Component({
  templateUrl: './tree.html'  
})
export class TreeComponent { 

    constructor() {
      this.ItemsSource = 
      [
        { Name:'Parent 1', 
          Children: [
            { Name:'Child 1', Children: [ { Name: 'Grandchild 1'}, { Name: 'Grandchild 2'} ] },
            { Name:'Child 2' }
          ]
        },
        { Name:'Parent 2' }
      ];
    }

    public ItemsSource;
    public SelectedItem;
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/tree/tree-component.ts